import { installationsActions } from './actions';
import { installationsMutations } from './mutations';
import { installationsGetters } from './getters';

const state = {
    cur_install_id: null,
    installations: {},
    is_filtred_by_geo: false
};
const actions = { ...installationsActions };
const mutations = { ...installationsMutations };
const getters = { ...installationsGetters };

// eslint-disable-next-line import/prefer-default-export
export const installationsStore = {
    state, getters, actions, mutations
};
